import {Component, OnInit, Input, OnChanges, AfterViewInit} from '@angular/core';
import {IVariantGrouping} from "../../Interfaces/IVariantGrouping";
import { IVariantGroupingType } from "../../Interfaces/IVariantGroupingType";
import {IStyle} from "../../Interfaces/IStyle";
import {IFinish} from "../../Interfaces/IFinish";
import {Scene7Helper} from "../../helpers/scene7.helper";
import {GeneralHelpers} from "../../helpers/general.helper";

@Component({
  selector: 'kws-style-card',
  templateUrl: './style-card.component.html'
})
export class StyleCardComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() product: IStyle;
  @Input() cat: string;
  @Input() type: string;
  finishes: any;
  slugifiedCategory: string;
  productUrl: string;
  urlType: string;

  constructor() { }

  ngOnInit() {
      this.slugifyCategory();
      this.urlType = this.type ? `&type=${this.type}` : '';
  }

  ngOnChanges(){
    this.finishes = this.product.finishCount;
  }

  ngAfterViewInit() {

  }

  getProductImage(product) {
      if(product){
        return Scene7Helper.imagePath(product, 'Kwikset', 'kwsProductLarge');
      } else {
        return Scene7Helper.imagePath('no-image', 'Kwikset', 'kwsProductLarge');
      }
  }

  slugifyCategory(){
      this.slugifiedCategory = GeneralHelpers.ensureUnique(GeneralHelpers.slugify(this.cat));
  }

  getUrl(product){
    if(product.unavailable || !product.selectedFinish) {
      return `/products/category/${this.slugifiedCategory}?style=${product.title}${this.urlType}`;
    } else {
      return `/products/category/${this.slugifiedCategory}?style=${product.title}${this.urlType}&finish=${this.getSlugifiedFinish(product.selectedFinish)}`;
    }
  }

  getSlugifiedFinish(finish){
    if(finish){
      finish = finish.replace(/ /g,"%20");
      return finish;
    }
  }

  showSignaturePopup(event, element){
    console.log(element.getElementsByClassName('js-collection-info')[0]);
      element.getElementsByClassName('js-collection-info')[0].classList.add('state-visible');
  }

  hideSignaturePopup(event, element) {
      element.getElementsByClassName('js-collection-info')[0].classList.remove('state-visible');
  }
}



// WEBPACK FOOTER //
// ./src/ts/Apps/Common/components/style-card/style-card.component.ts